import * as Mod1 from "./discourse/components/admin-dashboard-card";
import * as Mod2 from "./discourse/components/code-view";
import * as Mod3 from "./discourse/components/data-explorer-chart";
import * as Mod4 from "./discourse/components/data-explorer-workflow-ai-query";
import * as Mod5 from "./discourse/components/explorer-schema";
import * as Mod6 from "./discourse/components/explorer-schema/enum-info";
import * as Mod7 from "./discourse/components/explorer-schema/one-table";
import * as Mod8 from "./discourse/components/modal/query-help";
import * as Mod9 from "./discourse/components/param-input-form";
import * as Mod10 from "./discourse/components/param-input/boolean-three";
import * as Mod11 from "./discourse/components/param-input/category-id-input";
import * as Mod12 from "./discourse/components/param-input/group-input";
import * as Mod13 from "./discourse/components/param-input/user-id-input";
import * as Mod14 from "./discourse/components/param-input/user-list-input";
import * as Mod15 from "./discourse/components/query-ai-prompt";
import * as Mod16 from "./discourse/components/query-chart-empty-state";
import * as Mod17 from "./discourse/components/query-mode-switch";
import * as Mod18 from "./discourse/components/query-result-download-buttons";
import * as Mod19 from "./discourse/components/query-result";
import * as Mod20 from "./discourse/components/query-results-wrapper";
import * as Mod21 from "./discourse/components/query-row-content";
import * as Mod22 from "./discourse/components/query-run-split-button";
import * as Mod23 from "./discourse/components/query-tag-chooser";
import * as Mod24 from "./discourse/components/result-types/badge";
import * as Mod25 from "./discourse/components/result-types/category";
import * as Mod26 from "./discourse/components/result-types/group";
import * as Mod27 from "./discourse/components/result-types/hidden";
import * as Mod28 from "./discourse/components/result-types/html";
import * as Mod29 from "./discourse/components/result-types/json";
import * as Mod30 from "./discourse/components/result-types/post";
import * as Mod31 from "./discourse/components/result-types/reltime";
import * as Mod32 from "./discourse/components/result-types/reviewable";
import * as Mod33 from "./discourse/components/result-types/tag-group";
import * as Mod34 from "./discourse/components/result-types/text";
import * as Mod35 from "./discourse/components/result-types/topic";
import * as Mod36 from "./discourse/components/result-types/url";
import * as Mod37 from "./discourse/components/result-types/user";
import * as Mod38 from "./discourse/components/share-report";
import * as Mod39 from "./discourse/connectors/admin-dashboard-manage-reports-footer/data-explorer-hint.gjs";
import * as Mod40 from "./discourse/connectors/group-reports-nav-item/nav-item.gjs";
import * as Mod41 from "./discourse/controllers/admin-plugins/show/explorer";
import * as Mod42 from "./discourse/controllers/admin-plugins/show/explorer/edit";
import * as Mod43 from "./discourse/controllers/admin-plugins/show/explorer/index";
import * as Mod44 from "./discourse/controllers/admin-plugins/show/explorer/new";
import * as Mod45 from "./discourse/controllers/group/reports";
import * as Mod46 from "./discourse/controllers/group/reports/index";
import * as Mod47 from "./discourse/controllers/group/reports/show";
import * as Mod48 from "./discourse/explorer-legacy-route-map";
import * as Mod49 from "./discourse/explorer-route-map";
import * as Mod50 from "./discourse/group-reports-route-map";
import * as Mod51 from "./discourse/initializers/data-explorer-admin-plugin-configuration-nav";
import * as Mod52 from "./discourse/initializers/initialize-data-explorer";
import * as Mod53 from "./discourse/initializers/register-admin-dashboard-renderer";
import * as Mod54 from "./discourse/lib/ai-generation";
import * as Mod55 from "./discourse/lib/ai-query-availability";
import * as Mod56 from "./discourse/lib/chart-helpers";
import * as Mod57 from "./discourse/lib/constants";
import * as Mod58 from "./discourse/lib/data-explorer-store";
import * as Mod59 from "./discourse/lib/result-columns";
import * as Mod60 from "./discourse/lib/themeColor";
import * as Mod61 from "./discourse/models/query";
import * as Mod62 from "./discourse/routes/admin-plugins/explorer";
import * as Mod63 from "./discourse/routes/admin-plugins/explorer/index";
import * as Mod64 from "./discourse/routes/admin-plugins/explorer/queries";
import * as Mod65 from "./discourse/routes/admin-plugins/explorer/queries/edit";
import * as Mod66 from "./discourse/routes/admin-plugins/explorer/queries/index";
import * as Mod67 from "./discourse/routes/admin-plugins/show/explorer";
import * as Mod68 from "./discourse/routes/admin-plugins/show/explorer/edit";
import * as Mod69 from "./discourse/routes/admin-plugins/show/explorer/index";
import * as Mod70 from "./discourse/routes/admin-plugins/show/explorer/new";
import * as Mod71 from "./discourse/routes/group/reports";
import * as Mod72 from "./discourse/routes/group/reports/index";
import * as Mod73 from "./discourse/routes/group/reports/show";
import * as Mod74 from "./discourse/templates/group/reports";
import * as Mod75 from "./discourse/templates/group/reports/index";
import * as Mod76 from "./discourse/templates/group/reports/show";
const compatModules = {
  "discourse/components/admin-dashboard-card": Mod1,
  "discourse/components/code-view": Mod2,
  "discourse/components/data-explorer-chart": Mod3,
  "discourse/components/data-explorer-workflow-ai-query": Mod4,
  "discourse/components/explorer-schema": Mod5,
  "discourse/components/explorer-schema/enum-info": Mod6,
  "discourse/components/explorer-schema/one-table": Mod7,
  "discourse/components/modal/query-help": Mod8,
  "discourse/components/param-input-form": Mod9,
  "discourse/components/param-input/boolean-three": Mod10,
  "discourse/components/param-input/category-id-input": Mod11,
  "discourse/components/param-input/group-input": Mod12,
  "discourse/components/param-input/user-id-input": Mod13,
  "discourse/components/param-input/user-list-input": Mod14,
  "discourse/components/query-ai-prompt": Mod15,
  "discourse/components/query-chart-empty-state": Mod16,
  "discourse/components/query-mode-switch": Mod17,
  "discourse/components/query-result-download-buttons": Mod18,
  "discourse/components/query-result": Mod19,
  "discourse/components/query-results-wrapper": Mod20,
  "discourse/components/query-row-content": Mod21,
  "discourse/components/query-run-split-button": Mod22,
  "discourse/components/query-tag-chooser": Mod23,
  "discourse/components/result-types/badge": Mod24,
  "discourse/components/result-types/category": Mod25,
  "discourse/components/result-types/group": Mod26,
  "discourse/components/result-types/hidden": Mod27,
  "discourse/components/result-types/html": Mod28,
  "discourse/components/result-types/json": Mod29,
  "discourse/components/result-types/post": Mod30,
  "discourse/components/result-types/reltime": Mod31,
  "discourse/components/result-types/reviewable": Mod32,
  "discourse/components/result-types/tag-group": Mod33,
  "discourse/components/result-types/text": Mod34,
  "discourse/components/result-types/topic": Mod35,
  "discourse/components/result-types/url": Mod36,
  "discourse/components/result-types/user": Mod37,
  "discourse/components/share-report": Mod38,
  "discourse/connectors/admin-dashboard-manage-reports-footer/data-explorer-hint": Mod39,
  "discourse/connectors/group-reports-nav-item/nav-item": Mod40,
  "discourse/controllers/admin-plugins/show/explorer": Mod41,
  "discourse/controllers/admin-plugins/show/explorer/edit": Mod42,
  "discourse/controllers/admin-plugins/show/explorer/index": Mod43,
  "discourse/controllers/admin-plugins/show/explorer/new": Mod44,
  "discourse/controllers/group/reports": Mod45,
  "discourse/controllers/group/reports/index": Mod46,
  "discourse/controllers/group/reports/show": Mod47,
  "discourse/explorer-legacy-route-map": Mod48,
  "discourse/explorer-route-map": Mod49,
  "discourse/group-reports-route-map": Mod50,
  "discourse/initializers/data-explorer-admin-plugin-configuration-nav": Mod51,
  "discourse/initializers/initialize-data-explorer": Mod52,
  "discourse/initializers/register-admin-dashboard-renderer": Mod53,
  "discourse/lib/ai-generation": Mod54,
  "discourse/lib/ai-query-availability": Mod55,
  "discourse/lib/chart-helpers": Mod56,
  "discourse/lib/constants": Mod57,
  "discourse/lib/data-explorer-store": Mod58,
  "discourse/lib/result-columns": Mod59,
  "discourse/lib/themeColor": Mod60,
  "discourse/models/query": Mod61,
  "discourse/routes/admin-plugins/explorer": Mod62,
  "discourse/routes/admin-plugins/explorer/index": Mod63,
  "discourse/routes/admin-plugins/explorer/queries": Mod64,
  "discourse/routes/admin-plugins/explorer/queries/edit": Mod65,
  "discourse/routes/admin-plugins/explorer/queries/index": Mod66,
  "discourse/routes/admin-plugins/show/explorer": Mod67,
  "discourse/routes/admin-plugins/show/explorer/edit": Mod68,
  "discourse/routes/admin-plugins/show/explorer/index": Mod69,
  "discourse/routes/admin-plugins/show/explorer/new": Mod70,
  "discourse/routes/group/reports": Mod71,
  "discourse/routes/group/reports/index": Mod72,
  "discourse/routes/group/reports/show": Mod73,
  "discourse/templates/group/reports": Mod74,
  "discourse/templates/group/reports/index": Mod75,
  "discourse/templates/group/reports/show": Mod76,
};
export { compatModules };
export default compatModules;
